var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_5460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0008 7.20016C5.89113 7.20077 5.78241 7.18059 5.68088 7.14078C5.57935 7.10096 5.487 7.0423 5.40914 6.96816L0.409139 2.16815C0.252219 2.01751 0.164063 1.81319 0.164062 1.60015C0.164062 1.38711 0.252219 1.18279 0.409139 1.03215C0.566058 0.881506 0.778887 0.796875 1.00081 0.796875C1.22272 0.796875 1.43555 0.881506 1.59247 1.03215L6.0008 5.27216L10.4091 1.04015C10.5686 0.909088 10.7736 0.840602 10.9833 0.848379C11.1931 0.856156 11.392 0.939623 11.5404 1.0821C11.6888 1.22457 11.7758 1.41557 11.7839 1.61691C11.792 1.81825 11.7207 2.01511 11.5841 2.16815L6.58414 6.96816C6.42892 7.11595 6.21942 7.19928 6.0008 7.20016Z",
    fill: "#5DA196"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_5460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.68,
    fill: "white",
    transform: "translate(0 0.15625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGreen);
export default __webpack_public_path__ + "static/media/dropdownGreen.ebd725bea1aaf0f47bba850e901f1646.svg";
export { ForwardRef as ReactComponent };